import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { routes } from "./app.routes";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { DATE_PIPE_DEFAULT_OPTIONS, LocationStrategy } from "@angular/common";
import { httpRequestInterceptorFn } from "./shared/interceptors/http-request.interceptor";
import { NgxSpinnerModule } from "ngx-spinner";
import { PathPreserveQueryLocationStrategy } from "./path-preserve-query-location-strategy";
import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS } from "@angular/material/progress-spinner";
import { MAT_SELECT_CONFIG } from "@angular/material/select";
import { provideMomentDateAdapter } from "@angular/material-moment-adapter";

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideAnimationsAsync(),
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: "fill" } },
        { provide: MAT_SELECT_CONFIG, useValue: { hideSingleSelectionIndicator: true } },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { disableClose: true, autoFocus: false, width: 328 } },
        { provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS, useValue: { diameter: 50 } },
        { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: "dd MMM yyyy" } },
        provideMomentDateAdapter(
            {
                parse: {
                    dateInput: ["l", "LL"],
                },
                display: {
                    dateInput: "MMM D, YYYY",
                    monthYearLabel: "MMM YYYY",
                    dateA11yLabel: "LL",
                    monthYearA11yLabel: "MMMM YYYY",
                },
            },
            { strict: true },
        ),
        importProvidersFrom(NgxSpinnerModule),
        provideHttpClient(withInterceptors([httpRequestInterceptorFn])),
        { provide: LocationStrategy, useClass: PathPreserveQueryLocationStrategy },
    ],
};
